import {post,get} from '../../libs/ajax.js'

/**
 * 获取文件白名单列表
 * @param {*} data 
 * @param {*} options 
 * @returns 
 */
export const getfileWhiteListApi = (data, options) => {
    return get('/daily_task/file_whitelist/list', data, options)
}
/**
 * 删除白名单
 * @param {*} data 
 * @param {*} options 
 * @returns 
 */
export const delfileWhiteItemApi = (data, options) => {
    return post('/daily_task/file_whitelist/del', data, options)
}
/**
 * 添加文件白名单
 * @param {*} data 
 * @param {*} options 
 * @returns 
 */
export const addfileWhiteItemApi = (data, options) => {
    return post('/daily_task/file_whitelist/add', data, options)
}
/**
 * 队列列表
 * @param {*} data 
 * @param {*} options 
 * @returns 
 */
export const getFileSeparateQueueListApi = (data, options) => {
    return get('/daily_task/file_separate_queue/list', data, options)
}
/**
 * 删除队列
 * @param {*} data 
 * @param {*} options 
 * @returns 
 */
export const delFileSeparateQueueItemApi = (data, options) => {
    return post('/daily_task/file_separate_queue/del', data, options)
}
/**
 * 添加队列
 * @param {*} data 
 * @param {*} options 
 * @returns 
 */
export const addFileSeparateQueueItemApi = (data, options) => {
    return post('/daily_task/file_separate_queue/add', data, options)
}
